// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Souv6","formControl":"styles_formControl__JYDRC"};